module.exports = __webpack_public_path__ + "img/CAI.efff0f62.png";